export default "__VITE_PUBLIC_ASSET__4eed58b1__"